const SelectCountry = () => {
  // jQuery(document).ready(function ($) {
  //   $("#billing_country").select2();

  //   var billingCountry = $("#billing_country").val()

  //   $("#billing_country").val(null).trigger("change.select2");


  //   $("#billing_country").on('change', function () {
  //     billingCountry = $(this).val()
  //   });

  //   // $(window).on("beforeunload", function () {
  //   //   $("#billing_country").val(null).trigger("change.select2");
  //   // });
  // });
}

export default SelectCountry;

